import { render, staticRenderFns } from "./FormCrudProvideNumberPerRolls.vue?vue&type=template&id=6df272b5"
import script from "./FormCrudProvideNumberPerRolls.vue?vue&type=script&lang=js"
export * from "./FormCrudProvideNumberPerRolls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports